import { Navigate, useLocation } from "react-router-dom";

// Stale URLs from the previous site (and common CMS patterns) still sit in
// Google's index. Send them to the closest real page with a client-side
// redirect instead of showing a 404.
const LEGACY_REDIRECTS = {
  "/home": "/",
  "/index": "/",
  "/index.html": "/",
  "/index.php": "/",
  "/about-us": "/about",
  "/about-dr-mirza": "/about",
  "/meet-the-team": "/about",
  "/team": "/about",
  "/our-team": "/about",
  "/dr-nausheen-mirza": "/about",
  "/contact-us": "/contact",
  "/book": "/contact",
  "/book-online": "/contact",
  "/book-appointment": "/contact",
  "/appointments": "/contact",
  "/new-patients": "/contact",
  "/our-services": "/services",
  "/services-2": "/services",
  "/treatments": "/services",
  "/dental-services": "/services",
  "/invisalign": "/services#cosmetic",
  "/teeth-whitening": "/services#cosmetic",
  "/implants": "/services#restorative",
  "/dental-implants": "/services#restorative",
  "/emergency": "/services#specialized",
  "/emergency-dentistry": "/services#specialized",
  "/news": "/blog",
  "/blogs": "/blog",
  "/journal": "/blog",
  "/privacy-policy": "/privacy",
  "/terms-of-use": "/terms",
  "/terms-and-conditions": "/terms",
};

// Whole path prefixes that were never ours (old CMS author, tag and feed URLs).
const LEGACY_PREFIXES = ["/author", "/tag", "/category", "/wp-", "/feed"];

export function resolveLegacyPath(pathname) {
  const clean = pathname.replace(/\/+$/, "").toLowerCase() || "/";
  if (LEGACY_REDIRECTS[clean]) return LEGACY_REDIRECTS[clean];
  if (LEGACY_PREFIXES.some((p) => clean === p || clean.startsWith(`${p}/`) || clean.startsWith(p)))
    return "/";
  return null;
}

export default function LegacyRedirect({ children }) {
  const { pathname } = useLocation();
  const target = resolveLegacyPath(pathname);
  if (target) return <Navigate to={target} replace />;
  return children;
}
